module.exports = __webpack_public_path__ + "assets/devices/GSD-441-PG2-10f87f2cfa8d5a762323a588fe4fa761.svg";